
import React, { useState, useEffect, useContext } from 'react';
import { Box, Button, Text } from 'grommet';
import { Servers } from "grommet-icons"

import { CopyToClipboard } from 'react-copy-to-clipboard'

import UserContext from '../../context/UserContext'
import { useToasts } from 'react-toast-notifications'

const DC_MAP = {
        'chicago': "ch",
        'aurora': "ar",
        'new_york': "ny",
        'bangkok': 'bk',
        'basildon': 'ba',
        'frankfurt': "fr",
        'sydney': "sy",
        'singapore': "sg",
        'london': "ln",
        'toyko': "ty",
        'saopaulo': "sp"
}

const Spare = ({ datacenter, env, service_name }) => {

    const [command, setcommand] = useState("")
    const token = useContext(UserContext)
    const { addToast } = useToasts()

    useEffect(() => {

        const datacenterTruncated = DC_MAP[datacenter] ? DC_MAP[datacenter] : ''

        if (datacenterTruncated) {
            let finalCommand = "cd debesys;spare -e $env -d $dc -c $service"
            finalCommand = finalCommand.replace("$service", service_name).replace("$env", env).replace("$dc", datacenterTruncated)
            setcommand(finalCommand)
        }

    }, [env, service_name, datacenter])

    return (
        <>
                {command && env.includes("ext-") && token.scopes.indexOf("triage/ad") !== -1 &&
                    <CopyToClipboard text={command}>
                        <Box
                            justify="center"
                            align="center"
                            gap="none"
                            background="dark-2"
                            width="120px"
                            pad={{"top": "2px", "bottom": "2px"}}
                            alignSelf="center"
                            alignContent="center"
                            round="xsmall"
                            onClick={() => {
                                addToast("Spare Command Copied to Clipboard", {
                                    appearance: "success",
                                    autoDismiss: true,
                                })
                            }}

                        >
                            <Box alignSelf="center" margin={{ left: "6px", right: "6px" }}>
                                <Button plain label={<Text color="white" size="12px" weight="normal">SpareCmd</Text>} margin={{ top: "xxsmall" }} hoverIndicator={{ color: "light-1", opacity: "weak" }} icon={<Servers size="16px" color="white" />} />
                            </Box>
                        </Box>
                    </CopyToClipboard>
                }
        </>
    )
}

export default Spare
